// IMPORTS
// import _ from 'lodash'
import axios from 'axios'

const state = {
    isLoaded: false,
    bannersWeb: [],
    pagesContent: [],
    staticContent: [],
    portfolioContent: [],
    contentReplacers: [],
}

const getters = {
    catalogIsLoaded: (state) => {return state.isLoaded},
    catalogBannersWeb: (state) => {return state.bannersWeb},
    catalogPagesContent: (state) => {return state.pagesContent},
    catalogStaticContent: (state) => {return state.staticContent},
    catalogPortfolioContent: (state) => {return state.portfolioContent},
    catalogContentReplacers: (state) => {return state.contentReplacers},
}

const mutations = {
	catalogWrite: ( state, payload ) => {

        // SET CATALOG
        state.bannersWeb    = payload.bannersWeb
        state.portfolioContent = payload.portfolioContent
        state.pagesContent   = payload.pagesContent
        state.staticContent  = payload.staticContent
        state.contentReplacers = payload.contentReplacers

        // SET IS LOADED COMPELTE
        state.isLoaded      = true
    }
}

const actions = {

	catalogUpdate: async ({commit}) => {
        try {
            let response = await axios.get('catalogo/default')
            commit('catalogWrite', response.data)
        } catch(e){
            console.error(e)
        }
    },


}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};
